import {CURSOR, drawRectangle, getTextColor, GROUP_SECTION_WIDTH, GROUP_TYPE} from '../../canvas-timeline/canvas_timeline_util';
import Group from '../../canvas-timeline/canvas_timeline_group';
import {cacheManager} from '../../canvas-timeline/canvas_timeline_cache_manager';
import {interactionManager} from '../../canvas-timeline/canvas_timeline_interaction_manager';
import Util from '../../../../forecast-app/shared/util/util';

class NonProjectTimeGroup extends Group {
	constructor(data) {
		super(GROUP_TYPE.PEOPLE_SCHEDULING_NON_PROJECT_TIME, data);
	}

	draw(canvasContext, x, y, collapsableSectionHeight) {
		const width = GROUP_SECTION_WIDTH();
		const {data, height, expanded, groupType} = this;
		super.draw(x, y, width, height, this, collapsableSectionHeight);
		const {id} = data;
		const cacheId = `${groupType}-${id}-${!!expanded}`;

		interactionManager.addCursorStyleArea(x, y, width, height, CURSOR.POINTER, true);

		//Subtract 1 from width and height to make room for the grey border
		drawRectangle(canvasContext, 16, y, width - 16, height - 1, {
			borderColor: '#ebebee',
			borderThickness: 1,
			borderTopLeftRadius: 10,
			borderBottomLeftRadius: expanded ? 0 : 10,
		});

		const cachedData = cacheManager.get(groupType, cacheId);
		if (cachedData) {
			canvasContext.drawImage(cachedData, x, y, width, this.itemRowHeight);
			return;
		}

		canvasContext.fillStyle = getTextColor();
		canvasContext.font = '500 12px ' + Util.getFontFamily();
		canvasContext.fillText(data.name, x + 30, y + 23);
	}
}

export default NonProjectTimeGroup;
